/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScannerMappingDto } from './ScannerMappingDto';
import {
    ScannerMappingDtoFromJSON,
    ScannerMappingDtoFromJSONTyped,
    ScannerMappingDtoToJSON,
    ScannerMappingDtoToJSONTyped,
} from './ScannerMappingDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface VulnerabilityScannerMappingStalenessResponse
 */
export interface VulnerabilityScannerMappingStalenessResponse {
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    staleDays?: number;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    staleCount?: number;
    /**
     * 
     * @type {Array<ScannerMappingDto>}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    staleMappings?: Array<ScannerMappingDto>;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof VulnerabilityScannerMappingStalenessResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the VulnerabilityScannerMappingStalenessResponse interface.
 */
export function instanceOfVulnerabilityScannerMappingStalenessResponse(value: object): value is VulnerabilityScannerMappingStalenessResponse {
    return true;
}

export function VulnerabilityScannerMappingStalenessResponseFromJSON(json: any): VulnerabilityScannerMappingStalenessResponse {
    return VulnerabilityScannerMappingStalenessResponseFromJSONTyped(json, false);
}

export function VulnerabilityScannerMappingStalenessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VulnerabilityScannerMappingStalenessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'staleDays': json['staleDays'] == null ? undefined : json['staleDays'],
        'staleCount': json['staleCount'] == null ? undefined : json['staleCount'],
        'staleMappings': json['staleMappings'] == null ? undefined : ((json['staleMappings'] as Array<any>).map(ScannerMappingDtoFromJSON)),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function VulnerabilityScannerMappingStalenessResponseToJSON(json: any): VulnerabilityScannerMappingStalenessResponse {
    return VulnerabilityScannerMappingStalenessResponseToJSONTyped(json, false);
}

export function VulnerabilityScannerMappingStalenessResponseToJSONTyped(value?: VulnerabilityScannerMappingStalenessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'staleDays': value['staleDays'],
        'staleCount': value['staleCount'],
        'staleMappings': value['staleMappings'] == null ? undefined : ((value['staleMappings'] as Array<any>).map(ScannerMappingDtoToJSON)),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

